// path: src/app/models/cotizador/response/person-beneficiary.model.ts

import { PersonBeneficiary, Beneficiarios } from './cotizador/response/model.data.response';

export class PersonBeneficiaryModel implements PersonBeneficiary {
  name: string;
  secondname: string;
  lastname: string;
  secondsurname: string;
  gender: string;
  datebirth: string;
  tarifa: string;
  descriptionTarifa: string;
  age: string;
  type: string;
  typeDescripcion: string;
  position: number;
  isContract: boolean;
  email: string;
  movilNumber: string;
  phone: string;
  codigo_campania: string;
  campania: string;
  tipoDocumento: string;
  documento: string;
  lineOfBusiness: string;
  program: string;

  constructor() {
    this.name = '';
    this.secondname = '';
    this.lastname = '';
    this.secondsurname = '';
    this.gender = '';
    this.datebirth = '';
    this.tarifa = '';
    this.descriptionTarifa = '';
    this.age = '';
    this.type = '';
    this.typeDescripcion = '';
    this.position = 0;
    this.isContract = false;
    this.email = '';
    this.movilNumber = '';
    this.phone = '';
    this.codigo_campania = '';
    this.campania = '';
    this.tipoDocumento = '';
    this.documento = '';
    this.lineOfBusiness = '';
    this.program = '';
  }
}

export class BeneficiariosModel implements Beneficiarios {
  position: number;
  id_cotizacion: number;
  id_beneficiario?: number;
  es_contratante: boolean;
  parentesco_id: string;
  typeDescripcion: string;
  tipo_documento: string;
  num_documento: string;
  primer_nombre: string;
  segundo_nombre: string;
  primer_apellido: string;
  segundo_apellido: string;
  genero: string;
  fecha_nacimiento: string;
  edad: string;
  lineOfBusiness: string;
  program: string;
  tarifa: string;
  descriptionTarifa: string;
  email: string;
  movilNumber: string;
  phone: string;
  codigo_campania: string;
  campania: string;
  tipoVia: string;
  numero: string;
  placaUno: string;
  placaDos: string;
  ciudad: string;
  direccion: string;
  anexo: string;
  subcuenta: string;
  tarifaAnexo: string;

  constructor() {
    this.position = 0;
    this.id_cotizacion = 0;
    this.es_contratante = false;
    this.parentesco_id = '';
    this.typeDescripcion = '';
    this.tipo_documento = '';
    this.num_documento = '';
    this.primer_nombre = '';
    this.segundo_nombre = '';
    this.primer_apellido = '';
    this.segundo_apellido = '';
    this.genero = '';
    this.fecha_nacimiento = '';
    this.edad = '';
    this.lineOfBusiness = '';
    this.program = '';
    this.tarifa = '';
    this.descriptionTarifa = '';
    this.email = '';
    this.movilNumber = '';
    this.phone = '';
    this.codigo_campania = '';
    this.campania = '';
    this.tipoVia = '';
    this.numero = '';
    this.placaUno = '';
    this.placaDos = '';
    this.ciudad = '';
    this.direccion = '';
    this.anexo = '';
    this.subcuenta = '';
    this.tarifaAnexo = '';
  }

  /**
   * Normaliza y convierte Beneficiarios -> PersonBeneficiary
   * Tolera snake/camel y algunos typos que vimos en tus logs.
   */
  static toPersons( b: Beneficiarios ): PersonBeneficiary {
    const anyB = b as any;

    // Nombres y documento
    const primerNombre = anyB.primer_nombre || anyB.primerNombre || anyB.nombre || '';
    const segundoNombre = anyB.segundo_nombre || anyB.segundoNombre || '';
    const primerApellido = anyB.primer_apellido || anyB.primerApellido || anyB.apellido || '';
    const segundoApellido = anyB.segundo_apellido || anyB.segundoApellido || '';

    const tipoDocumento = anyB.tipo_documento || anyB.tipoDocumento || '';
    const numDocumento = anyB.num_documento || anyB.numDocumento || '';

    // Otros
    const genero = anyB.genero || anyB.gender || '';
    const fechaNac = anyB.fecha_nacimiento || anyB.fechaNacimiento || '';
    const edad = anyB.edad != null ? String( anyB.edad ) : '';

    // L�nea / Programa (incluye typo visto: lineoFBusiness)
    const lineOfBusiness = anyB.lineOfBusiness || anyB.lineoFBusiness || anyB.lineaDeNegocio || '';
    const program = anyB.program || anyB.programa || '';

    // Contacto (incluye typo moviNumber)
    const movilNumber = anyB.movilNumber || anyB.moviNumber || anyB.celular || '';
    const phone = anyB.phone || anyB.telefono || '';

    // Parentesco
    const type = anyB.parentesco_id || anyB.parentescoId || '';
    const typeDescripcion = anyB.typeDescripcion || anyB.parentesco || '';

    // Campa�a
    const codigo_campania = anyB.codigo_campania || '';
    const campania = anyB.campania || '';

    // Extras
    const tarifa = anyB.tarifa || '';
    const descriptionTarifa = anyB.descriptionTarifa || '';

    const position = anyB.position || 0;
    const isContract = anyB.es_contratante || false;

    return {
      // Identificaci�n
      tipoDocumento,
      documento: numDocumento,

      // Nombres
      name: primerNombre,
      secondname: segundoNombre,
      lastname: primerApellido,
      secondsurname: segundoApellido,

      // Otros
      gender: genero,
      datebirth: fechaNac,
      age: edad,

      // Parentesco
      type,
      typeDescripcion,

      // Posici�n/flags
      position,
      isContract,

      // Contacto
      email: anyB.email || '',
      movilNumber,
      phone,

      // Campa�a
      codigo_campania,
      campania,

      // Programa/L�nea
      lineOfBusiness,
      program,

      // Extras
      tarifa,
      descriptionTarifa,
    };
  }

  /**
   * Convierte PersonBeneficiary -> BeneficiariosModel
   * �til para volver a la grilla si �sta usa Beneficiarios[] o para enviar al backend.
   */
  static fromPersons( p: PersonBeneficiary ): BeneficiariosModel {
    const m = new BeneficiariosModel();

    // Identificaci�n
    m.tipo_documento = p.tipoDocumento || '';
    m.num_documento = p.documento || '';

    // Nombres
    m.primer_nombre = p.name || '';
    m.segundo_nombre = p.secondname || '';
    m.primer_apellido = p.lastname || '';
    m.segundo_apellido = p.secondsurname || '';

    // Otros
    m.genero = p.gender || '';
    m.fecha_nacimiento = p.datebirth || '';
    m.edad = p.age || '';

    // Parentesco
    m.parentesco_id = p.type || '';
    m.typeDescripcion = p.typeDescripcion || '';

    // Posici�n/flags
    m.position = p.position || 0;
    m.es_contratante = p.isContract || false;

    // Contacto
    m.email = p.email || '';
    m.movilNumber = p.movilNumber || '';
    m.phone = p.phone || '';

    // Campa�a
    m.codigo_campania = p.codigo_campania || '';
    m.campania = p.campania || '';

    // Programa/L�nea
    m.lineOfBusiness = p.lineOfBusiness || '';
    m.program = p.program || '';

    // Extras
    m.tarifa = p.tarifa || '';
    m.descriptionTarifa = p.descriptionTarifa || '';

    return m;
  }
}